import { useState } from 'react';
import CategoryButton from './CategoryButton';
import TarjetaPOS from './TarjetaPOS';
import AddedCart from './AddedCart';
import CircleButton from './CircleButton';
import CloseOrden from './CloseOrden';
import Busqueda from './Busqueda';
import TarjetaPedidos from './TarjetaPedidos';
import EditarAzulButton from '../Utils/EditarAzulButton';
import DeleteIconCircle from './DeleteIconCircle';
import categoryIcons from '../Utils/categoryIcons';
import VariantesAnadirButton from '../Utils/VariantesAnadirButton';
import StockBadge from '../Utils/StockBadge';
import BadgedMetricas from '../Utils/BadgedMetricas';
import DetallesBlue from '../Utils/DetallesBlue';
import {
  IconArrowLeft,
  IconArrowRight,
  IconCheck,
  IconCashBanknoteFilled,
  IconCreditCardFilled,
  IconHome2Filled,
  IconArchiveFilled,
  IconMotorbikeFilled,
  IconUser,
  IconClipboardCheck,
  IconClipboardList,
  IconPackage,
  IconPlus,
  IconChevronDown,
  IconChevronRight,
  IconTrashXFilled,
  IconX,
  IconPencilFilled,
  IconDiscount2,
  IconReceipt,
  IconSun,
  IconCalendar,
  IconBuildingStore,
  IconTruck,
  IconCircleCheckFilled,
  IconCircleXFilled,
  IconSettings,
  IconRocket,
  IconQuestionMark,
} from '@tabler/icons-react';

const FONT = '"Public Sans", sans-serif';

const PRODUCTS = [
  { name: 'Capuchino', price: '55.00' },
  { name: 'Latte', price: '49.00' },
  { name: 'Americano', price: '38.00' },
];

function SlideCatalogue() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex items-center justify-center gap-3 shrink-0">
        <CategoryButton name="Cafés" icon="coffee" color="#C08552" active onClick={() => {}} />
        <CategoryButton name="Desayunos" icon="breakfast" color="rgba(255, 255, 255, 0.45)" onClick={() => {}} />
        <CategoryButton name="Bebidas" icon="drink" color="#3B82F6" onClick={() => {}} />
      </div>
      <div className="grid gap-3 items-stretch" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
        {PRODUCTS.map((p) => (
          <TarjetaPOS
            key={p.name}
            name={p.name}
            price={p.price}
            image="/CoffeDummy.png"
            onAdd={() => {}}
          />
        ))}
      </div>
    </div>
  );
}

function OptionRow({ name, delta, checked }) {
  return (
    <div
      className="flex items-center gap-2.5 w-full"
      style={{
        minHeight: '40px',
        padding: '6px 8px',
        borderRadius: '12px',
        backgroundColor: checked ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
        fontSize: '14px',
        fontFamily: FONT,
        color: checked ? '#fff' : '#6F6F6F',
      }}
    >
      <span
        className="flex items-center justify-center shrink-0"
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '9999px',
          backgroundColor: checked ? '#fff' : 'rgba(255, 255, 255, 0.1)',
        }}
      >
        {checked && <IconCheck size={14} color="#000" stroke={3} />}
      </span>
      <span style={{ flex: 1 }}>{name}</span>
      {delta != null && (
        <span
          style={{
            fontSize: '12px',
            fontWeight: 500,
            color: '#fff',
            backgroundColor: '#0071e3',
            borderRadius: '9999px',
            padding: '2px 10px',
            fontFamily: FONT,
            flexShrink: 0,
          }}
        >
          {delta > 0 ? '+' : ''}${delta.toFixed(2)}
        </span>
      )}
    </div>
  );
}

function SlideCustomize() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex items-center justify-center gap-4" style={{ paddingBottom: '8px' }}>
        <img
          src="/CoffeDummy.png"
          alt="Capuchino"
          style={{ width: '56px', height: '56px', borderRadius: '12px', objectFit: 'contain', backgroundColor: 'rgba(255,255,255,0.06)' }}
        />
        <div>
          <span className="text-white font-semibold" style={{ fontSize: '15px', fontFamily: FONT }}>
            Personaliza tu artículo
          </span>
          <span className="block text-[rgba(255, 255, 255, 0.45)]" style={{ fontSize: '13px', fontFamily: FONT }}>
            Capuchino · $55.00
          </span>
        </div>
      </div>

      <div className="grid gap-4" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-white font-medium" style={{ fontSize: '14px', fontFamily: FONT }}>
              Tamaño
            </span>
            <span
              style={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#F97316',
                backgroundColor: 'rgba(249, 115, 22, 0.12)',
                borderRadius: '9999px',
                padding: '2px 10px',
                fontFamily: FONT,
              }}
            >
              Requerido
            </span>
          </div>
          <div
            className="flex flex-col gap-1.5"
            style={{ borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '12px' }}
          >
            <OptionRow name="Chico" delta={null} checked={false} />
            <OptionRow name="Mediano" delta={5} checked />
            <OptionRow name="Grande" delta={10} checked={false} />
          </div>
        </div>

        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="text-white font-medium" style={{ fontSize: '14px', fontFamily: FONT }}>
              Leche
            </span>
          </div>
          <div
            className="flex flex-col gap-1.5"
            style={{ borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '12px' }}
          >
            <OptionRow name="Entera" delta={null} checked />
            <OptionRow name="Deslactosada" delta={0} checked={false} />
            <OptionRow name="Almendra" delta={8} checked={false} />
          </div>
        </div>
      </div>

      <div
        className="flex items-center justify-between gap-4 shrink-0"
        style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', paddingTop: '16px' }}
      >
        <div>
          <span className="block" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>
            Total
          </span>
          <span className="block font-semibold" style={{ fontSize: '22px', color: '#fff', fontFamily: FONT }}>
            $60.00
          </span>
        </div>
        <button
          className="flex items-center justify-center gap-2 font-medium cursor-pointer"
          style={{
            height: '40px',
            padding: '0 20px',
            borderRadius: '9999px',
            backgroundColor: '#0071e3',
            color: '#fff',
            fontSize: '14px',
            fontFamily: FONT,
            border: 'none',
          }}
        >
          Agregar
        </button>
      </div>
    </div>
  );
}

function SlideOrder() {
  return (
    <div className="flex gap-4 w-full items-start justify-center">
      <div className="flex flex-col gap-2.5" style={{ width: '360px', flexShrink: 0 }}>
        <AddedCart
          name="Capuchino"
          price="55.00"
          image="/CoffeDummy.png"
          variants={[{ option_name: 'Mediano, Entera' }]}
          quantity={1}
          onModify={() => {}}
          onDelete={() => {}}
        />
        <AddedCart
          name="Latte"
          price="98.00"
          image="/CoffeDummy.png"
          variants={[{ option_name: 'Grande, Almendra' }]}
          quantity={2}
          onModify={() => {}}
          onDelete={() => {}}
        />
      </div>

      <div
        className="flex flex-col gap-3 shrink-0"
        style={{ width: '260px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.08)', padding: '16px' }}
      >
        <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
          Resumen
        </span>
        {[
          ['Subtotal', '$153.00'],
          ['Impuesto (16%)', '$24.48'],
        ].map(([label, value]) => (
          <div key={label} className="flex items-center justify-between">
            <span className="text-[rgba(255, 255, 255, 0.45)]" style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT }}>{label}</span>
            <span className="text-white" style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT }}>{value}</span>
          </div>
        ))}
        <div className="flex items-center justify-between pt-2" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>Total</span>
          <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>$177.48</span>
        </div>
        <button
          className="w-full py-2.5 rounded-full bg-[#0071e3] text-white font-medium border-none cursor-pointer"
          style={{ fontFamily: FONT }}
        >
          Pagar
        </button>
      </div>
    </div>
  );
}

function SlideCheckout() {
  return (
    <div className="flex gap-6 w-full items-start justify-center">
      <div className="flex flex-col gap-5" style={{ width: '330px', flexShrink: 0 }}>
        <div>
          <span className="text-white font-semibold block mb-3" style={{ fontSize: '14px', fontFamily: FONT }}>
            Método de pago
          </span>
          <div className="flex gap-3">
            <CircleButton icon={IconCashBanknoteFilled} active onClick={() => {}} label="Efectivo" />
            <CircleButton icon={IconCreditCardFilled} onClick={() => {}} label="Débito" />
            <CircleButton icon={IconCreditCardFilled} onClick={() => {}} label="Crédito" />
          </div>
        </div>

        <div>
          <span className="text-white font-semibold block mb-3" style={{ fontSize: '14px', fontFamily: FONT }}>
            Tipo de pedido
          </span>
          <div className="flex gap-3">
            <CircleButton icon={IconHome2Filled} active onClick={() => {}} label="En tienda" size="sm" />
            <CircleButton icon={IconArchiveFilled} onClick={() => {}} label="Pickup" size="sm" />
            <CircleButton icon={IconMotorbikeFilled} onClick={() => {}} label="Domicilio" size="sm" />
          </div>
        </div>

        <div>
          <span className="text-white font-semibold block mb-3" style={{ fontSize: '14px', fontFamily: FONT }}>
            Cliente
          </span>
          <div className="flex items-center gap-3" style={{ backgroundColor: 'rgba(255, 255, 255, 0.035)', borderRadius: '14px', padding: '10px 12px' }}>
            <div
              className="flex items-center justify-center shrink-0"
              style={{ width: '34px', height: '34px', borderRadius: '9999px', backgroundColor: '#fff' }}
            >
              <IconUser size={16} color="#000" />
            </div>
            <div className="flex flex-col min-w-0">
              <span className="text-white truncate" style={{ fontSize: '14px', fontWeight: 600, fontFamily: FONT }}>
                @marta
              </span>
              <span className="text-[rgba(255, 255, 255, 0.45)] truncate" style={{ fontSize: '13px', fontWeight: 500, fontFamily: FONT }}>
                Marta Ruiz · 120 pts
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="flex flex-col justify-between shrink-0"
        style={{ width: '260px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.08)', padding: '16px', minHeight: '150px' }}
      >
        <div className="flex flex-col gap-3">
          <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
            Resumen
          </span>
          {[
            ['Artículos', '2'],
            ['Subtotal', '$153.00'],
            ['Impuesto (16%)', '$24.48'],
          ].map(([label, value]) => (
            <div key={label} className="flex items-center justify-between">
              <span className="text-[rgba(255, 255, 255, 0.45)]" style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT }}>{label}</span>
              <span className="text-white" style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT }}>{value}</span>
            </div>
          ))}
          <div className="flex items-center justify-between pt-2" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>Total</span>
            <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>$177.48</span>
          </div>
        </div>
        <div className="flex justify-end pt-4">
          <CloseOrden onClick={() => {}} />
        </div>
      </div>
    </div>
  );
}

const LEVANTAR_PEDIDO_SLIDES = [
  {
    caption: 'Menú de venta',
    title: 'Agrega items a tu orden',
    text: 'Explora las categorías y toca el botón + de la tarjeta de cada producto para agregarlo. Así armas tu orden directamente desde el menú.',
    visual: <SlideCatalogue />,
  },
  {
    caption: 'Personalizar artículo',
    title: 'Modifica y escoge sus variantes',
    text: 'Si el producto tiene opciones, elige las que prefieras. Las que suman precio muestran su diferencia. Si el artículo ya está en tu orden, usa Modificar para ajustarlo.',
    visual: <SlideCustomize />,
  },
  {
    caption: 'Panel de la orden',
    title: 'Revisa tu orden',
    text: 'En el panel derecho confirmas cantidad, variantes y precio antes de cobrar. Ajusta con Modificar o elimina un artículo si hiciste un cambio.',
    visual: <SlideOrder />,
  },
  {
    caption: 'Cierre de pedido',
    title: 'Cobra la orden',
    text: 'Elige el método de pago, el tipo de pedido y el cliente. Verifica el resumen y toca Confirmar y cobrar. Si pagaron en efectivo, ingresa cuánto recibiste.',
    visual: <SlideCheckout />,
  },
];

const noop = () => {};

const now = Date.now();

function PedidoColumn({ title, count, children }) {
  return (
    <div className="flex flex-col gap-2" style={{ flex: '1 1 0', minWidth: '200px' }}>
      <div className="flex items-center justify-between">
        <span className="text-white font-semibold m-0" style={{ fontSize: '16px', fontFamily: FONT }}>
          {title}
        </span>
        <span
          className="inline-flex items-center justify-center"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '9999px',
            height: '22px',
            padding: '0 10px',
            fontSize: '13px',
            fontWeight: 500,
            fontFamily: FONT,
            color: '#fff',
          }}
        >
          {count} Pedidos
        </span>
      </div>
      {children}
    </div>
  );
}

function SlidePedidosResumen() {
  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="flex items-center justify-between shrink-0">
        <div>
          <span className="block text-white font-semibold uppercase" style={{ fontSize: '16px', fontFamily: FONT }}>
            Gestión de pedidos
          </span>
          <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>
            Administra y da seguimiento a los pedidos
          </span>
        </div>
        <Busqueda value="" onChange={noop} />
      </div>
      <div className="flex gap-3 w-full">
        <PedidoColumn title="Pendientes" count={1}>
          <TarjetaPedidos
            nombre="Marta Ruiz"
            fecha="17/09/2026"
            hora="11:30"
            dia="Jueves"
            unidades={2}
            section="pending"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
        <PedidoColumn title="En progreso" count={2}>
          <TarjetaPedidos
            nombre="Luis García"
            fecha="17/09/2026"
            hora="11:15"
            dia="Jueves"
            unidades={3}
            section="in_progress"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
        <PedidoColumn title="Listos" count={1}>
          <TarjetaPedidos
            nombre="Ana Torres"
            fecha="17/09/2026"
            hora="10:50"
            dia="Jueves"
            unidades={1}
            section="ready"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
      </div>
    </div>
  );
}

function SlideAceptarPedido() {
  return (
    <div className="flex gap-4 w-full items-start justify-center">
      <div className="flex flex-col gap-3" style={{ width: '280px', flexShrink: 0 }}>
        <PedidoColumn title="Pendientes" count={1}>
          <TarjetaPedidos
            nombre="Marta Ruiz"
            fecha="17/09/2026"
            hora="11:30"
            dia="Jueves"
            unidades={2}
            section="pending"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
      </div>
      <div
        className="flex flex-col items-center gap-2 shrink-0"
        style={{ width: '220px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.08)', padding: '16px' }}
      >
        <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
          Toma el pedido
        </span>
        <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.5, fontFamily: FONT }}>
          Toca <b style={{ color: '#fff' }}>Aceptar</b> en un pedido pendiente y pasa a
        </p>
        <div
          className="flex items-center justify-center"
          style={{
            backgroundColor: 'rgba(34, 197, 94, 0.15)',
            borderRadius: '9999px',
            height: '24px',
            padding: '0 10px',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: FONT,
            color: '#22C55E',
          }}
        >
          En progreso
        </div>
        <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.5, fontFamily: FONT }}>
          Ahí arranca el temporizador y el equipo sabe que ya se está preparando.
        </p>
      </div>
    </div>
  );
}

function SlideCerrarPedido() {
  return (
    <div className="flex gap-4 w-full items-start justify-center">
      <div className="flex flex-col gap-3" style={{ width: '280px', flexShrink: 0 }}>
        <PedidoColumn title="En progreso" count={1}>
          <TarjetaPedidos
            nombre="Luis García"
            fecha="17/09/2026"
            hora="11:15"
            dia="Jueves"
            unidades={3}
            section="in_progress"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
        <PedidoColumn title="Listos" count={1}>
          <TarjetaPedidos
            nombre="Ana Torres"
            fecha="17/09/2026"
            hora="10:50"
            dia="Jueves"
            unidades={1}
            section="ready"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
      </div>
      <div
        className="flex flex-col items-center gap-2 shrink-0"
        style={{ width: '220px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.08)', padding: '16px' }}
      >
        <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
          Cierra la orden
        </span>
        <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.5, fontFamily: FONT }}>
          Cuando el pedido esté listo, toca <b style={{ color: '#fff' }}>Cerrar</b> y la tarjeta pasa a
        </p>
        <div
          className="flex items-center justify-center"
          style={{
            backgroundColor: 'rgba(34, 197, 94, 0.15)',
            borderRadius: '9999px',
            height: '24px',
            padding: '0 10px',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: FONT,
            color: '#22C55E',
          }}
        >
          Listos
        </div>
        <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.5, fontFamily: FONT }}>
          y se marca como <span style={{ color: '#22C55E' }}>Completado</span>.
        </p>
      </div>
    </div>
  );
}

function SlideDetallesCancelar() {
  return (
    <div className="flex gap-4 w-full items-start justify-center">
      <div className="flex flex-col gap-3" style={{ width: '280px', flexShrink: 0 }}>
        <PedidoColumn title="En progreso" count={2}>
          <TarjetaPedidos
            nombre="Luis García"
            fecha="17/09/2026"
            hora="11:15"
            dia="Jueves"
            unidades={3}
            section="in_progress"
            createdAt={now}
            startTime={now}
            readyAt={now}
            isClosing={false}
            onCancelar={noop}
            onAceptarPedido={noop}
            onCerrarPedido={noop}
            onVerDetalles={noop}
          />
        </PedidoColumn>
      </div>
      <div
        className="flex flex-col gap-3 shrink-0"
        style={{ width: '260px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.08)', padding: '16px' }}
      >
        <div className="flex items-center gap-3">
          <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
            Opciones del pedido
          </span>
        </div>
        <div className="flex flex-col gap-3">
          {[
            ['Ver detalles', 'Abre el pedido con sus artículos.', '#fff', '#000'],
            ['Aceptar / Cerrar', 'Mueven la tarjeta entre estados.', '#0071e3', '#fff'],
            ['Cancelar', 'Pide una clave de autorización.', '#DC0A0B', '#fff'],
          ].map(([label, caption, bg, fg]) => (
            <div key={label} className="flex flex-col gap-1">
              <div
                className="flex items-center justify-center"
                style={{
                  height: '36px',
                  padding: '0 12px',
                  borderRadius: '9999px',
                  backgroundColor: bg,
                  fontSize: '13px',
                  fontWeight: 600,
                  fontFamily: FONT,
                  color: fg,
                }}
              >
                {label}
              </div>
              <span className="text-center" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.4, fontFamily: FONT }}>
                {caption}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const GESTION_PEDIDOS_SLIDES = [
  {
    caption: 'Pantalla principal',
    title: 'Tres columnas por estado',
    text: 'Cada pedido cae en una columna según su estado: Pendientes, En progreso y Listos. Usa la búsqueda para encontrar un pedido por el nombre del cliente o su código.',
    visual: <SlidePedidosResumen />,
  },
  {
    caption: 'Aceptar pedido',
    title: 'Toma el pedido entrante',
    text: 'Toca Aceptar en un pedido pendiente. Pasa a En progreso y arranca el temporizador de preparación.',
    visual: <SlideAceptarPedido />,
  },
  {
    caption: 'Cerrar pedido',
    title: 'Ciérralo cuando esté listo',
    text: 'Al terminar la preparación toca Cerrar. La tarjeta pasa a Listos y queda marcada como Completado.',
    visual: <SlideCerrarPedido />,
  },
  {
    caption: 'Detalles y cancelación',
    title: 'Detalles y botones de acción',
    text: 'Ver detalles muestra la información completa del pedido. Cancelar pide una clave de autorización para evitar cancelaciones accidentales.',
    visual: <SlideDetallesCancelar />,
  },
];

/* ---------------------- Guía: Gestión de artículos ---------------------- */

const ARTICULOS_ROWS = [
  {
    id: 1,
    nombre: 'Capuchino',
    categorias: ['Cafés'],
    precio: '$55.00',
    variantes: ['Capuchino Chico', 'Capuchino Grande'],
  },
  {
    id: 2,
    nombre: 'Croissant de mantequilla',
    categorias: ['Desayunos'],
    precio: '$38.00',
    variantes: [],
  },
  {
    id: 3,
    nombre: 'Jugo de naranja',
    categorias: ['Bebidas'],
    precio: '$32.00',
    variantes: ['Vaso', 'Botella'],
  },
];

const TUTORIAL_RING = '0 0 0 3px #FFFFFF';

const articulosBadge = {
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: '9999px',
  height: '28px',
  padding: '0 12px',
  fontSize: '13px',
  fontWeight: 500,
  fontFamily: FONT,
  color: '#fff',
  whiteSpace: 'nowrap',
};

const articulosWhitePill = {
  backgroundColor: '#fff',
  borderRadius: '9999px',
  height: '28px',
  padding: '0 12px',
  fontSize: '13px',
  fontWeight: 500,
  fontFamily: FONT,
  color: '#000',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

function ArticulosTable({ highlightRow = null, selectedIds = [], highlightDelete = false }) {
  const cols = [
    { key: 'id', flex: 1, minWidth: '60px', label: 'ID' },
    { key: 'nombre', flex: 2, minWidth: '150px', label: 'Nombre' },
    { key: 'categoria', flex: 1.2, minWidth: '110px', label: 'Categoría' },
    { key: 'precio', flex: 1, minWidth: '90px', label: 'Precio' },
    { key: 'variantes', flex: 1.2, minWidth: '120px', label: 'Variantes' },
    { key: 'editar', flex: 0, minWidth: '100px', label: '' },
    { key: 'eliminar', flex: 0, minWidth: '52px', label: '' },
  ];
  const showSelect = selectedIds.length > 0;

  const cell = (flex, minWidth, extra = {}) => ({
    flex,
    minWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: FONT,
    ...extra,
  });

  return (
    <div
      className="flex flex-col w-full shrink-0"
      style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255, 255, 255, 0.06)' }}
    >
      <div className="flex items-center" style={{ padding: '0 16px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.04)' }}>
        {showSelect && <div style={{ width: '56px', flexShrink: 0 }} />}
        {cols.map((c) => (
          <span
            key={c.key}
            className="text-white font-bold flex items-center justify-center"
            style={{ flex: c.flex, minWidth: c.minWidth, fontSize: '13px', fontFamily: FONT }}
          >
            {c.label}
          </span>
        ))}
      </div>

      {ARTICULOS_ROWS.map((row) => {
        const isSel = selectedIds.includes(row.id);
        const editHighlight = highlightRow === row.id;
        const delHighlight = highlightDelete && isSel;
        return (
          <div
            key={row.id}
            className="flex items-center"
            style={{
              padding: '0 16px',
              height: '46px',
              backgroundColor: isSel ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
              borderTop: '1px solid rgba(255, 255, 255, 0.05)',
            }}
          >
            {showSelect && (
              <div
                className="flex items-center justify-center shrink-0"
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '9999px',
                  backgroundColor: isSel ? '#fff' : 'rgba(255, 255, 255, 0.12)',
                  marginRight: '24px',
                }}
              >
                {isSel && <IconCheck size={14} color="#000" stroke={3} />}
              </div>
            )}
            <span style={cell(1, '60px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.id}</span>
            <span style={cell(2, '150px', { color: '#fff', fontWeight: 600 })}>{row.nombre}</span>
            <span style={cell(1.2, '110px')}>
              <span style={articulosBadge}>{row.categorias[0]}</span>
            </span>
            <span style={cell(1, '90px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.precio}</span>
            <span style={cell(1.2, '120px')}>
              {row.variantes.length === 0 ? (
                <span style={{ fontSize: '13px', fontWeight: 500, fontFamily: FONT, color: 'rgba(255, 255, 255, 0.45)' }}>Sin variantes</span>
              ) : (
                <span style={articulosWhitePill}>
                  Ver más
                  <IconChevronRight size={12} color="#000" />
                </span>
              )}
            </span>
            <span
              className="flex items-center justify-center"
              style={{ flex: 0, minWidth: '100px', ...(editHighlight ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}) }}
            >
              <EditarAzulButton onClick={noop} />
            </span>
            <span
              className="flex items-center justify-center"
              style={{ flex: 0, minWidth: '52px', ...(delHighlight ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}) }}
            >
              <DeleteIconCircle onClick={noop} size={30} />
            </span>
          </div>
        );
      })}
    </div>
  );
}

function ArticulosHeader({ highlightAdd = false }) {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Gestión de artículos
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Administra el catálogo de productos
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Busqueda value="" onChange={noop} />
        <span
          className="flex items-center justify-center"
          style={highlightAdd ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
        >
          <button
            className="flex items-center justify-center gap-1.5"
            style={{
              height: '32px',
              padding: '0 16px',
              borderRadius: '9999px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: '#0071e3',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: FONT,
            }}
          >
            <IconPlus size={16} />
            Agregar
          </button>
        </span>
      </div>
    </div>
  );
}

function ModalNuevoArticulo() {
  const fieldLabel = { fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT };
  const fieldInput = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    borderRadius: '9999px',
    height: '40px',
    padding: '0 16px',
    fontSize: '14px',
    fontFamily: FONT,
    color: '#fff',
    width: '100%',
    boxSizing: 'border-box',
  };
  return (
    <div
      className="flex flex-col gap-4 shrink-0"
      style={{ width: '340px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.16)', backgroundColor: '#000', padding: '20px' }}
    >
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Nuevo artículo
      </span>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Nombre</label>
        <input value="Capuchino" readOnly style={fieldInput} />
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Categoría</label>
        <div
          className="flex items-center justify-between"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '9999px', height: '40px', padding: '0 16px' }}
        >
          <span style={{ fontSize: '14px', fontFamily: FONT, color: '#fff' }}>Cafés</span>
          <IconChevronDown size={15} color="rgba(255, 255, 255, 0.45)" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Precio</label>
        <input value="$55.00" readOnly style={fieldInput} />
      </div>
      <div className="flex items-center justify-center gap-2 mt-1">
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#fff', color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconArrowLeft size={15} />
          Regresar
        </div>
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#0071e3', color: '#fff', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconCheck size={15} />
          Guardar
        </div>
      </div>
    </div>
  );
}

function SlideArticulos() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <ArticulosHeader />
      <ArticulosTable />
    </div>
  );
}

function SlideAgregarArticulo() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <ArticulosHeader highlightAdd />
      <ModalNuevoArticulo />
    </div>
  );
}

function SlideEditarArticulo() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <ArticulosHeader />
      <ArticulosTable highlightRow={1} />
    </div>
  );
}

function SlideEliminarArticulo() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <ArticulosHeader />
      <ArticulosTable selectedIds={[1, 3]} highlightDelete />
      <div className="flex items-center justify-center shrink-0">
        <div
          className="flex items-center gap-2"
          style={{ height: '40px', padding: '0 16px', borderRadius: '9999px', backgroundColor: '#000', border: '1px solid rgba(255, 255, 255, 0.16)', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.4)' }}
        >
          <span style={{ fontSize: '13px', fontWeight: 600, color: '#fff', fontFamily: FONT, marginRight: '4px' }}>2</span>
          <div
            className="flex items-center gap-1"
            style={{ height: '30px', padding: '0 12px', borderRadius: '9999px', backgroundColor: 'rgba(255, 255, 255, 0.1)', color: '#fff', fontSize: '13px', fontWeight: 500, fontFamily: FONT }}
          >
            <IconX size={13} color="#fff" />
            Deseleccionar
          </div>
          <div
            className="flex items-center gap-1"
            style={{ height: '30px', padding: '0 12px', borderRadius: '9999px', backgroundColor: '#DC0A0B', color: '#fff', fontSize: '13px', fontWeight: 500, fontFamily: FONT }}
          >
            <IconTrashXFilled size={13} color="#fff" />
            Eliminar
          </div>
        </div>
      </div>
    </div>
  );
}

const ARTICULOS_SLIDES = [
  {
    caption: 'Pantalla principal',
    title: 'Catálogo de productos',
    text: 'Todos tus artículos aparecen en una tabla con ID, nombre, categoría, precio y variantes. Usa la búsqueda para encontrar un producto o toca Agregar para incluir uno nuevo.',
    visual: <SlideArticulos />,
  },
  {
    caption: 'Agregar artículo',
    title: 'Añade un nuevo producto',
    text: 'Toca Agregar y se abre el formulario. Completa al menos nombre, categoría y precio; luego Guardar lo publica de inmediato en el catálogo.',
    visual: <SlideAgregarArticulo />,
  },
  {
    caption: 'Editar artículo',
    title: 'Actualiza su información',
    text: 'Con el botón azul Editar de cada fila puedes modificar nombre, precios, imágenes y variantes del artículo sin perder su historial.',
    visual: <SlideEditarArticulo />,
  },
  {
    caption: 'Eliminar artículos',
    title: 'Selección múltiple',
    text: 'Marca la casilla de uno o varios artículos. Con el icono rojo los eliminas uno por uno, o con la barra inferior puedes deseleccionar o borrarlos en grupo.',
    visual: <SlideEliminarArticulo />,
  },
];

/* ----------------- Guía: Variantes, categorías y promociones ----------------- */

const VARIANTES_MOCK = [
  { name: 'Tamaño', color: '#3B82F6' },
  { name: 'Temperatura', color: 'rgba(255, 255, 255, 0.45)' },
  { name: 'Extras', color: '#22D3EE' },
];

const CATEGORIAS_MOCK = [
  { name: 'Cafés', color: '#C08552', icon: 'coffee' },
  { name: 'Desayunos', color: '#F59E0B', icon: 'breakfast' },
  { name: 'Bebidas', color: '#3B82F6', icon: 'drink' },
];

const PROMOS_MOCK = [
  { name: '15% en postres', color: '#22D3EE' },
  { name: '2x1 en cafés', color: '#A78BFA' },
  { name: 'Jugo 30% off', color: '#34D399' },
];

function hexToRgba(hex, alpha) {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function PillPromoMock({ name, color, icon, highlight = false }) {
  const IconComp = icon ? categoryIcons[icon] : null;
  return (
    <div
      className="flex items-center gap-2"
      style={{
        width: '100%',
        backgroundColor: hexToRgba(color, 0.1),
        borderRadius: '9999px',
        height: '34px',
        padding: '0 6px 0 12px',
        ...(highlight ? { boxShadow: TUTORIAL_RING } : {}),
      }}
    >
      {IconComp && <IconComp size={15} color={color} style={{ flexShrink: 0 }} />}
      <span
        style={{
          flex: 1,
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '13px',
          fontWeight: 500,
          fontFamily: FONT,
          color,
        }}
      >
        {name}
      </span>
      <span
        className="flex items-center justify-center shrink-0"
        style={{
          width: '22px',
          height: '22px',
          borderRadius: '9999px',
          backgroundColor: '#fff',
          ...(highlight ? { boxShadow: TUTORIAL_RING } : {}),
        }}
      >
        <IconPencilFilled size={11} color="#000" />
      </span>
    </div>
  );
}

function SeccionColumnaMock({ title, subtitle, items, highlightAdd = false }) {
  return (
    <div className="flex flex-col gap-3 shrink-0" style={{ flex: '1 1 0', minWidth: '210px' }}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
            {title}
          </span>
          <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
            {subtitle}
          </span>
        </div>
        <span
          className="flex items-center justify-center shrink-0"
          style={highlightAdd ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
        >
          <VariantesAnadirButton onClick={noop} />
        </span>
      </div>
      <div
        className="flex flex-col gap-2"
        style={{ flex: 1, backgroundColor: 'rgba(255, 255, 255, 0.08)', borderRadius: '16px', padding: '12px', minHeight: '124px' }}
      >
        {items.map((it) => (
          <PillPromoMock key={it.name} {...it} />
        ))}
      </div>
    </div>
  );
}

function PromosHeader() {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Promociones por categoría
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Administra las variantes y promociones de cada categoría
        </span>
      </div>
      <Busqueda value="" onChange={noop} />
    </div>
  );
}

function SlidePromosVista() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <PromosHeader />
      <div className="flex gap-4 w-full">
        <SeccionColumnaMock title="Variantes" subtitle="Opciones configurables" items={VARIANTES_MOCK} />
        <SeccionColumnaMock title="Categorías" subtitle="Agrupaciones del catálogo" items={CATEGORIAS_MOCK} />
        <SeccionColumnaMock title="Promociones" subtitle="Descuentos y ofertas" items={PROMOS_MOCK} />
      </div>
    </div>
  );
}

function SlidePromosCrear() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <PromosHeader />
      <div className="flex gap-4 w-full justify-center">
        <SeccionColumnaMock title="Variantes" subtitle="Opciones configurables" items={VARIANTES_MOCK} highlightAdd />
        <SeccionColumnaMock title="Categorías" subtitle="Agrupaciones del catálogo" items={CATEGORIAS_MOCK} highlightAdd />
      </div>
    </div>
  );
}

function SlidePromosPromos() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <PromosHeader />
      <div style={{ width: '260px' }}>
        <SeccionColumnaMock title="Promociones" subtitle="Descuentos y ofertas" items={PROMOS_MOCK} highlightAdd />
      </div>
    </div>
  );
}

function SlidePromosEditar() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <PromosHeader />
      <div style={{ width: '300px' }}>
        <SeccionColumnaMock
          title="Categorías"
          subtitle="Agrupaciones del catálogo"
          items={[{ ...CATEGORIAS_MOCK[0], highlight: true }, CATEGORIAS_MOCK[1], CATEGORIAS_MOCK[2]]}
        />
      </div>
    </div>
  );
}

const PROMOCIONES_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Tres secciones en una pantalla',
    text: 'La página se divide en Variantes, Categorías y Promociones. Cada elemento se ve como una píldora de color con su botón de edición.',
    visual: <SlidePromosVista />,
  },
  {
    caption: 'Crear elementos',
    title: 'Usa el botón + de cada sección',
    text: 'El botón azul + abre el formulario de esa sección: para variantes defines opciones del producto, para categorías creas agrupaciones y para promociones armas descuentos.',
    visual: <SlidePromosCrear />,
  },
  {
    caption: 'Promociones',
    title: 'Descuentos y ofertas',
    text: 'En Promociones puedes crear un descuento por categoría (porcentaje, monto fijo o 2x1) o por artículo individual fijando un precio nuevo.',
    visual: <SlidePromosPromos />,
  },
  {
    caption: 'Editar y mantener',
    title: 'El lápiz blanco en cada píldora',
    text: 'Cada píldora tiene un lápiz blanco que abre la edición de ese elemento. Desde ahí puedes actualizar su configuración o eliminarlo.',
    visual: <SlidePromosEditar />,
  },
];

/* ------------------- Guía: Inventario ------------------- */

const INVENTARIO_ROWS = [
  { nombre: 'Café tostado', unidad: 'gramos', cantidad: '250', minimo: '100', maximo: '500', proveedor: 'Roasters MX' },
  { nombre: 'Leche entera', unidad: 'ml', cantidad: '120', minimo: '200', maximo: '600', proveedor: 'Lácteos del Valle' },
  { nombre: 'Azúcar refinada', unidad: 'gramos', cantidad: '280', minimo: '200', maximo: '800', proveedor: 'Dulces y Más' },
  { nombre: 'Jarabe de vainilla', unidad: 'ml', cantidad: '60', minimo: '40', maximo: '200', proveedor: 'FlavorPro' },
];

function InventarioTableMock({ highlightRow = null, highlightEdit = false, highlightDelete = false, rowRing = false }) {
  const cols = [
    { key: 'nombre', flex: 2, minWidth: '150px', label: 'Nombre' },
    { key: 'unidad', flex: 0.8, minWidth: '64px', label: 'Unidad' },
    { key: 'cantidad', flex: 0.9, minWidth: '56px', label: 'Cantidad' },
    { key: 'minimo', flex: 0.8, minWidth: '56px', label: 'Stock Mín' },
    { key: 'maximo', flex: 0.8, minWidth: '56px', label: 'Stock Máx' },
    { key: 'proveedor', flex: 1.2, minWidth: '100px', label: 'Proveedor' },
    { key: 'estado', flex: 0.9, minWidth: '82px', label: 'Estado' },
    { key: 'editar', flex: 0, minWidth: '96px', label: '' },
    { key: 'eliminar', flex: 0, minWidth: '48px', label: '' },
  ];

  const cell = (flex, minWidth, extra = {}) => ({
    flex,
    minWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: FONT,
    ...extra,
  });

  const badgeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '9999px',
    height: '26px',
    padding: '0 10px',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: FONT,
    color: '#fff',
    whiteSpace: 'nowrap',
  };

  return (
    <div
      className="flex flex-col w-full shrink-0"
      style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255, 255, 255, 0.06)' }}
    >
      <div className="flex items-center" style={{ padding: '0 12px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.04)' }}>
        {cols.map((c) => (
          <span
            key={c.key}
            className="text-white font-bold flex items-center justify-center"
            style={{ flex: c.flex, minWidth: c.minWidth, fontSize: '12px', fontFamily: FONT }}
          >
            {c.label}
          </span>
        ))}
      </div>

      {INVENTARIO_ROWS.map((row) => {
        const isHighlighted = highlightRow === row.id;
        const isSel = isHighlighted && rowRing;
        return (
          <div
            key={row.id}
            className="flex items-center"
            style={{
              padding: '0 12px',
              height: '44px',
              backgroundColor: isSel ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
              borderTop: '1px solid rgba(255, 255, 255, 0.05)',
              ...(isHighlighted && rowRing ? { boxShadow: TUTORIAL_RING } : {}),
            }}
          >
            <span style={cell(2, '150px', { color: '#fff', fontWeight: 600 })}>{row.nombre}</span>
            <span style={cell(0.8, '64px')}>
              <span style={badgeStyle}>{row.unidad}</span>
            </span>
            <span style={cell(0.9, '56px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.cantidad}</span>
            <span style={cell(0.8, '56px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.minimo}</span>
            <span style={cell(0.8, '56px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.maximo}</span>
            <span style={cell(1.2, '100px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.proveedor}</span>
            <span style={cell(0.9, '82px')}>
              <StockBadge current={Number(row.cantidad)} minimum={Number(row.minimo)} />
            </span>
            <span
              className="flex items-center justify-center"
              style={{ flex: 0, minWidth: '96px', ...(isHighlighted && highlightEdit ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}) }}
            >
              <EditarAzulButton onClick={noop} />
            </span>
            <span
              className="flex items-center justify-center"
              style={{ flex: 0, minWidth: '48px', ...(isHighlighted && highlightDelete ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}) }}
            >
              <DeleteIconCircle onClick={noop} size={30} />
            </span>
          </div>
        );
      })}
    </div>
  );
}

function InventarioHeader({ highlightAdd = false }) {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Inventario
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Control de insumos y existencias
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Busqueda value="" onChange={noop} />
        <span
          className="flex items-center justify-center"
          style={highlightAdd ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
        >
          <button
            className="flex items-center justify-center gap-1.5"
            style={{
              height: '32px',
              padding: '0 16px',
              borderRadius: '9999px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: '#0071e3',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: FONT,
            }}
          >
            <IconPlus size={16} />
            Agregar
          </button>
        </span>
      </div>
    </div>
  );
}

function ModalNuevoInsumo() {
  const fieldLabel = { fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT };
  const fieldInput = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    borderRadius: '9999px',
    height: '40px',
    padding: '0 16px',
    fontSize: '14px',
    fontFamily: FONT,
    color: '#fff',
    width: '100%',
    boxSizing: 'border-box',
  };
  return (
    <div
      className="flex flex-col gap-4 shrink-0"
      style={{ width: '340px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.16)', backgroundColor: '#000', padding: '20px' }}
    >
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Nuevo insumo
      </span>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Nombre</label>
        <input value="Café tostado" readOnly style={fieldInput} />
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Unidad de medida</label>
        <div
          className="flex items-center justify-between"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '9999px', height: '40px', padding: '0 16px' }}
        >
          <span style={{ fontSize: '14px', fontFamily: FONT, color: '#fff' }}>gramos</span>
          <IconChevronDown size={15} color="rgba(255, 255, 255, 0.45)" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Cantidad actual</label>
        <input value="250" readOnly style={fieldInput} />
      </div>
      <div className="flex items-center justify-center gap-2 mt-1">
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#fff', color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconArrowLeft size={15} />
          Regresar
        </div>
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#0071e3', color: '#fff', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconCheck size={15} />
          Guardar
        </div>
      </div>
    </div>
  );
}

function SlideInventarioVista() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <InventarioHeader />
      <InventarioTableMock />
    </div>
  );
}

function SlideInventarioAgregar() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <InventarioHeader highlightAdd />
      <ModalNuevoInsumo />
    </div>
  );
}

function SlideInventarioBase() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <InventarioHeader />
      <InventarioTableMock highlightRow={1} rowRing />
      <div
        className="flex items-center gap-3 shrink-0"
        style={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.035)', border: '1px solid rgba(255, 255, 255, 0.16)', padding: '12px 16px' }}
      >
        <span
          className="flex items-center justify-center shrink-0"
          style={{ width: '28px', height: '28px', borderRadius: '9999px', backgroundColor: 'rgba(255, 255, 255, 0.12)' }}
        >
          <IconPackage size={15} color="#fff" />
        </span>
        <span style={{ fontSize: '13px', fontWeight: 500, color: '#B5B5B5', lineHeight: 1.5, fontFamily: FONT }}>
          Solo los insumos de esta tabla aparecen como ingredientes seleccionables al armar la receta de un artículo.
        </span>
      </div>
    </div>
  );
}

function SlideInventarioStock() {
  const samples = [
    { current: 500, minimum: 100, caption: 'Stock suficiente para operar' },
    { current: 140, minimum: 100, caption: 'Se acerca al mínimo, conviene reabastecer' },
    { current: 90, minimum: 100, caption: 'Igual o debajo del stock mínimo' },
  ];
  return (
    <div className="flex flex-col gap-5 w-full items-center">
      <InventarioHeader />
      <div className="flex flex-col gap-3" style={{ width: '340px' }}>
        {samples.map((s, i) => (
          <div
            key={i}
            className="flex items-center justify-between"
            style={{ borderRadius: '14px', backgroundColor: 'rgba(255, 255, 255, 0.035)', border: '1px solid rgba(255, 255, 255, 0.16)', padding: '10px 14px' }}
          >
            <StockBadge current={s.current} minimum={s.minimum} />
            <span style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>
              {s.caption}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function SlideInventarioEditar() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <InventarioHeader />
      <InventarioTableMock highlightRow={1} highlightEdit highlightDelete />
    </div>
  );
}

const INVENTARIO_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Tu inventario completo',
    text: 'La tabla muestra cada insumo con su unidad, cantidad, stock mínimo y máximo, proveedor y estado. Usa la búsqueda por nombre o toca Agregar para crear un insumo.',
    visual: <SlideInventarioVista />,
  },
  {
    caption: 'Agregar insumo',
    title: 'Crea el insumo primero',
    text: 'Toca Agregar y completa al menos nombre, unidad de medida, cantidad y un stock mínimo. Así sabrás cuándo reabastecer.',
    visual: <SlideInventarioAgregar />,
  },
  {
    caption: 'La base de los ingredientes',
    title: 'El inventario alimenta tus recetas',
    text: 'Estos insumos son los únicos que podrás elegir como ingredientes al armar la receta de un artículo. Si un material no está aquí, no aparecerá en la lista de ingredientes.',
    visual: <SlideInventarioBase />,
  },
  {
    caption: 'Estado del stock',
    title: 'Verde u naranja, al instante',
    text: 'La insignia de estado te avisa: OK cuando hay existencias suficientes, Bajo cuando te acercas al mínimo y Crítico cuando ya estás igual o debajo.',
    visual: <SlideInventarioStock />,
  },
  {
    caption: 'Editar y eliminar',
    title: 'Actualiza o retira insumos',
    text: 'Editar abre el formulario para corregir cantidades, proveedor o mínimos. El icono rojo elimina el insumo y también puedes borrar varios marcando sus casillas.',
    visual: <SlideInventarioEditar />,
  },
];

/* ------------------- Guía: Registro de ventas ------------------- */

const VENTAS_ROWS = [
  { id: 'ORD-000021', cliente: 'Marta Ruiz', tipo: 'En tienda', estado: 'ready', recibido: '$165.00', fecha: '18/09/2026' },
  { id: 'ORD-000022', cliente: 'Luis García', tipo: 'Domicilio', estado: 'completed', recibido: '$340.50', fecha: '18/09/2026' },
  { id: 'ORD-000023', cliente: 'Ana Torres', tipo: 'Pickup', estado: 'cancelled', recibido: '-$48.00', fecha: '18/09/2026' },
];

function VentasStatusBadge({ status }) {
  const config = {
    ready: { icon: IconCircleCheckFilled, color: '#22c55e', label: 'Listo' },
    completed: { icon: IconCircleCheckFilled, color: '#22c55e', label: 'Completado' },
    cancelled: { icon: IconCircleXFilled, color: '#F97316', label: 'Cancelado' },
  }[status];
  const StatusIcon = config.icon;
  return (
    <span
      className="inline-flex items-center gap-2"
      style={{ borderRadius: '9999px', height: '30px', padding: '0 10px 0 4px', backgroundColor: 'rgba(255, 255, 255, 0.15)', whiteSpace: 'nowrap' }}
    >
      <span className="flex items-center justify-center shrink-0" style={{ width: '22px', height: '22px', borderRadius: '9999px', backgroundColor: '#000' }}>
        <StatusIcon size={13} color={config.color} />
      </span>
      <span style={{ fontSize: '12px', fontWeight: 500, fontFamily: FONT, color: '#fff' }}>{config.label}</span>
    </span>
  );
}

const TicketArrow = () => (
  <span className="flex items-center justify-center" style={{ width: '32px', height: '32px', borderRadius: '9999px', backgroundColor: '#fff' }}>
    <IconArrowRight size={14} color="#000" />
  </span>
);

function VentasTableMock({ highlightRow = null, highlightEstado = false, highlightTicket = false, highlightDetails = false, highlightDelete = false }) {
  const badgeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '9999px',
    height: '26px',
    padding: '0 10px',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: FONT,
    color: '#fff',
    whiteSpace: 'nowrap',
  };

  const cell = (flex, minWidth, extra = {}) => ({
    flex,
    minWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: FONT,
    ...extra,
  });

  const isH = (r, flag) => highlightRow === r && flag;

  return (
    <div
      className="flex flex-col w-full shrink-0"
      style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255, 255, 255, 0.06)' }}
    >
      <div className="flex items-center" style={{ padding: '0 12px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.04)' }}>
        {[
          { key: 'id', flex: 0.7, minWidth: '96px', label: 'ID' },
          { key: 'cliente', flex: 1.6, minWidth: '120px', label: 'Cliente' },
          { key: 'tipo', flex: 0.9, minWidth: '86px', label: 'Tipo' },
          { key: 'estado', flex: 1, minWidth: '106px', label: 'Estado' },
          { key: 'recibido', flex: 0.9, minWidth: '76px', label: 'Recibido' },
          { key: 'fecha', flex: 0.8, minWidth: '88px', label: 'Fecha' },
          { key: 'ticket', flex: 0, minWidth: '36px', label: '' },
          { key: 'detalles', flex: 0, minWidth: '104px', label: '' },
          { key: 'eliminar', flex: 0, minWidth: '40px', label: '' },
        ].map((c) => (
          <span
            key={c.key}
            className="text-white font-bold flex items-center justify-center"
            style={{ flex: c.flex, minWidth: c.minWidth, fontSize: '12px', fontFamily: FONT }}
          >
            {c.label}
          </span>
        ))}
      </div>

      {VENTAS_ROWS.map((row, i) => {
        const id = i + 1;
        const cancelled = row.estado === 'cancelled';
        return (
          <div
            key={row.id}
            className="flex items-center"
            style={{ padding: '0 12px', height: '44px', borderTop: '1px solid rgba(255, 255, 255, 0.05)' }}
          >
            <span style={cell(0.7, '96px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.id}</span>
            <span style={cell(1.6, '120px', { color: '#fff', fontWeight: 600 })}>{row.cliente}</span>
            <span style={cell(0.9, '86px')}>
              <span style={badgeStyle}>{row.tipo}</span>
            </span>
            <span
              className="flex items-center justify-center"
              style={cell(1, '106px', isH(id, highlightEstado) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <VentasStatusBadge status={row.estado} />
            </span>
            <span style={cell(0.9, '76px', { color: cancelled ? '#F97316' : 'rgba(255, 255, 255, 0.45)' })}>{row.recibido}</span>
            <span style={cell(0.8, '88px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.fecha}</span>
            <span
              className="flex items-center justify-center"
              style={cell(0, '36px', isH(id, highlightTicket) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <TicketArrow />
            </span>
            <span
              className="flex items-center justify-center"
              style={cell(0, '104px', isH(id, highlightDetails) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <DetallesBlue onClick={noop} />
            </span>
            <span
              className="flex items-center justify-center"
              style={cell(0, '40px', isH(id, highlightDelete) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <DeleteIconCircle onClick={noop} size={30} />
            </span>
          </div>
        );
      })}
    </div>
  );
}

function VentasHeader() {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Registro de ventas
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Historial y detalle de ventas
        </span>
      </div>
      <Busqueda value="" onChange={noop} />
    </div>
  );
}

function MetricasRowMock() {
  return (
    <div className="flex items-center gap-2 shrink-0">
      <BadgedMetricas color="#60A5FA" label="ventas" value="12" icon={IconReceipt} />
      <BadgedMetricas color="#A3A3A3" label="artículos" value="38" icon={IconPackage} />
      <BadgedMetricas color="#34d399" label="día" value="$1,420.00" icon={IconSun} />
      <BadgedMetricas color="#FB923C" label="mes" value="$18,650.00" icon={IconCalendar} />
      <BadgedMetricas color="#C084FC" label="comisión" value="$247.80" icon={IconCreditCardFilled} />
    </div>
  );
}

function SelectRowMock({ highlight = false }) {
  const pill = {
    height: '38px',
    borderRadius: '9999px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.16)',
    padding: '0 38px 0 16px',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: FONT,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  };
  const chev = {
    position: 'absolute',
    right: '7px',
    width: '24px',
    height: '24px',
    borderRadius: '9999px',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  return (
    <span
      className="flex items-center gap-2 shrink-0 w-fit"
      style={highlight ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
    >
      <span style={pill}>
        septiembre
        <span style={chev}>
          <IconChevronDown size={14} color="#000" />
        </span>
      </span>
      <span style={pill}>
        2026
        <span style={chev}>
          <IconChevronDown size={14} color="#000" />
        </span>
      </span>
    </span>
  );
}

function SlideVentasVista() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <VentasHeader />
      <MetricasRowMock />
      <SelectRowMock />
      <VentasTableMock />
    </div>
  );
}

function SlideVentasMetricas() {
  return (
    <div className="flex flex-col gap-5 w-full items-center">
      <VentasHeader />
      <span className="flex items-center justify-center" style={{ borderRadius: '9999px', boxShadow: TUTORIAL_RING, padding: '2px' }}>
        <MetricasRowMock />
      </span>
    </div>
  );
}

function SlideVentasFiltrar() {
  return (
    <div className="flex flex-col gap-5 w-full items-center">
      <VentasHeader />
      <SelectRowMock highlight />
    </div>
  );
}

function SlideVentasEstado() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <VentasHeader />
      <VentasTableMock highlightRow={2} highlightEstado highlightTicket />
    </div>
  );
}

function SlideVentasDetalles() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <VentasHeader />
      <VentasTableMock highlightRow={1} highlightDetails highlightDelete />
    </div>
  );
}

const VENTAS_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Historial de ventas',
    text: 'La página reúne las ventas cerradas del mes: métricas arriba, filtros por mes y año, y una tabla con estado, montos y acciones por venta.',
    visual: <SlideVentasVista />,
  },
  {
    caption: 'Métricas del mes',
    title: 'Tu negocio en insignias',
    text: 'Las píldoras resumen el período: ventas, artículos, ventas de hoy y del mes, comisión y descuentos. También hay un contador por tipo de venta.',
    visual: <SlideVentasMetricas />,
  },
  {
    caption: 'Filtrar por período',
    title: 'Elige mes y año',
    text: 'Usa los selectores de mes y año para ver solo las ventas de ese período. La tabla y las métricas se actualizan automáticamente.',
    visual: <SlideVentasFiltrar />,
  },
  {
    caption: 'Estados y ticket',
    title: 'Listo, Completado o Cancelado',
    text: 'Cada venta muestra su estado con su insignia. La flecha blanca reenvía el ticket al cliente cuando es necesario.',
    visual: <SlideVentasEstado />,
  },
  {
    caption: 'Detalles y eliminar',
    title: 'Revisa o retira una venta',
    text: 'Ver detalles abre el pedido completo con cada artículo. El icono rojo elimina la venta tras pedirte una clave de autorización.',
    visual: <SlideVentasDetalles />,
  },
];

/* ------------------- Guía: Registro de gastos ------------------- */

const GASTOS_ROWS = [
  { fecha: '18/09/2026', descripcion: 'Renta del local', categoria: 'Renta', monto: '$8,500.00' },
  { fecha: '16/09/2026', descripcion: 'Compra de café', categoria: 'Insumos', monto: '$1,240.00' },
  { fecha: '14/09/2026', descripcion: 'Electricidad', categoria: 'Servicios', monto: '$950.00' },
  { fecha: '11/09/2026', descripcion: 'Limpieza', categoria: 'Servicios', monto: '$300.00' },
];

function GastosTotalBadgeMock() {
  return (
    <div className="inline-flex items-center gap-2 shrink-0" style={{ backgroundColor: '#F973161A', borderRadius: '9999px', height: '32px', padding: '0 14px' }}>
      <span style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT, color: '#F97316' }}>$11,240.00</span>
      <span style={{ fontSize: '13px', fontWeight: 500, fontFamily: FONT, color: 'rgba(255, 255, 255, 0.45)' }}>Gastos</span>
    </div>
  );
}

function GastosHeader({ highlightAdd = false }) {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Gastos
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Compras y gastos registrados
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Busqueda value="" onChange={noop} />
        <span
          className="flex items-center justify-center"
          style={highlightAdd ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
        >
          <button
            className="flex items-center justify-center gap-1.5"
            style={{
              height: '32px',
              padding: '0 16px',
              borderRadius: '9999px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: '#0071e3',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: FONT,
            }}
          >
            <IconPlus size={16} />
            Agregar
          </button>
        </span>
      </div>
    </div>
  );
}

function GastosTableMock({ highlightRow = null, highlightEdit = false, highlightDelete = false }) {
  const badgeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '9999px',
    height: '26px',
    padding: '0 10px',
    fontSize: '12px',
    fontWeight: 500,
    fontFamily: FONT,
    color: '#fff',
    whiteSpace: 'nowrap',
  };

  const cell = (flex, minWidth, extra = {}) => ({
    flex,
    minWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: FONT,
    ...extra,
  });

  const isH = (r, flag) => highlightRow === r && flag;

  return (
    <div
      className="flex flex-col w-full shrink-0"
      style={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(255, 255, 255, 0.06)' }}
    >
      <div className="flex items-center" style={{ padding: '0 12px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.04)' }}>
        {[
          { key: 'fecha', flex: 0.9, minWidth: '96px', label: 'Fecha' },
          { key: 'descripcion', flex: 2.5, minWidth: '200px', label: 'Descripción' },
          { key: 'categoria', flex: 1, minWidth: '120px', label: 'Categoría' },
          { key: 'monto', flex: 1, minWidth: '110px', label: 'Monto' },
          { key: 'editar', flex: 0, minWidth: '96px', label: '' },
          { key: 'eliminar', flex: 0, minWidth: '44px', label: '' },
        ].map((c) => (
          <span
            key={c.key}
            className="text-white font-bold flex items-center justify-center"
            style={{ flex: c.flex, minWidth: c.minWidth, fontSize: '12px', fontFamily: FONT }}
          >
            {c.label}
          </span>
        ))}
      </div>

      {GASTOS_ROWS.map((row, i) => {
        const id = i + 1;
        return (
          <div
            key={id}
            className="flex items-center"
            style={{ padding: '0 12px', height: '44px', borderTop: '1px solid rgba(255, 255, 255, 0.05)' }}
          >
            <span style={cell(0.9, '96px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.fecha}</span>
            <span style={cell(2.5, '200px', { color: '#fff', fontWeight: 600 })}>{row.descripcion}</span>
            <span style={cell(1, '120px')}>
              <span style={badgeStyle}>{row.categoria}</span>
            </span>
            <span style={cell(1, '110px', { color: 'rgba(255, 255, 255, 0.45)' })}>{row.monto}</span>
            <span
              className="flex items-center justify-center"
              style={cell(0, '96px', isH(id, highlightEdit) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <EditarAzulButton onClick={noop} />
            </span>
            <span
              className="flex items-center justify-center"
              style={cell(0, '44px', isH(id, highlightDelete) ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {})}
            >
              <DeleteIconCircle onClick={noop} size={30} />
            </span>
          </div>
        );
      })}
    </div>
  );
}

function ModalNuevoGasto() {
  const fieldLabel = { fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT };
  const fieldInput = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    borderRadius: '9999px',
    height: '40px',
    padding: '0 16px',
    fontSize: '14px',
    fontFamily: FONT,
    color: '#fff',
    width: '100%',
    boxSizing: 'border-box',
  };
  return (
    <div
      className="flex flex-col gap-4 shrink-0"
      style={{ width: '340px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.16)', backgroundColor: '#000', padding: '20px' }}
    >
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Nuevo gasto
      </span>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Descripción</label>
        <input value="Compra de café" readOnly style={fieldInput} />
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Categoría</label>
        <div
          className="flex items-center justify-between"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: '9999px', height: '40px', padding: '0 16px' }}
        >
          <span style={{ fontSize: '14px', fontFamily: FONT, color: '#fff' }}>Insumos</span>
          <IconChevronDown size={15} color="rgba(255, 255, 255, 0.45)" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <label style={fieldLabel}>Monto</label>
        <input value="$1,240.00" readOnly style={fieldInput} />
      </div>
      <div className="flex items-center justify-center gap-2 mt-1">
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#fff', color: '#000', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconArrowLeft size={15} />
          Regresar
        </div>
        <div
          className="flex items-center justify-center gap-1.5"
          style={{ height: '38px', padding: '0 20px', borderRadius: '9999px', backgroundColor: '#0071e3', color: '#fff', fontSize: '14px', fontWeight: 500, fontFamily: FONT }}
        >
          <IconCheck size={15} />
          Guardar
        </div>
      </div>
    </div>
  );
}

function SlideGastosVista() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <GastosHeader />
      <GastosTotalBadgeMock />
      <SelectRowMock />
      <GastosTableMock />
    </div>
  );
}

function SlideGastosAgregar() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <GastosHeader highlightAdd />
      <ModalNuevoGasto />
    </div>
  );
}

function SlideGastosFiltrar() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <GastosHeader />
      <SelectRowMock highlight />
    </div>
  );
}

function SlideGastosEditar() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <GastosHeader />
      <GastosTableMock highlightRow={2} highlightEdit />
    </div>
  );
}

function SlideGastosEliminar() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <GastosHeader />
      <GastosTableMock highlightRow={2} highlightDelete />
    </div>
  );
}

const GASTOS_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Control de tus gastos',
    text: 'El total del mes se muestra en la insignia naranja. Abajo, la tabla lista cada gasto con fecha, descripción, categoría y monto.',
    visual: <SlideGastosVista />,
  },
  {
    caption: 'Agregar gasto',
    title: 'Registra cualquier compra',
    text: 'Toca Agregar, describe el gasto, elige su categoría y anota el monto. Guardar lo suma de inmediato al total del mes.',
    visual: <SlideGastosAgregar />,
  },
  {
    caption: 'Filtrar por período',
    title: 'Mes y año',
    text: 'Los selectores de mes y año muestran solo los gastos de ese período y recalculan el total automáticamente.',
    visual: <SlideGastosFiltrar />,
  },
  {
    caption: 'Editar gasto',
    title: 'Corrige descripción o monto',
    text: 'Con el botón azul Editar puedes cambiar la descripción, la categoría, la fecha o el monto de un gasto registrado.',
    visual: <SlideGastosEditar />,
  },
  {
    caption: 'Eliminar gastos',
    title: 'Retíralos individualmente o en grupo',
    text: 'El icono rojo elimina un gasto. También puedes marcar varios con sus casillas y borrarlos juntos.',
    visual: <SlideGastosEliminar />,
  },
];

/* ------------------- Guía: Gestión diaria ------------------- */

const DIARIA_DAYS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

const DIARIA_CATEGORIES = [
  { name: 'Bebidas', active: 6, inactive: 2 },
  { name: 'Comida', active: 4, inactive: 1 },
];

const DIARIA_PRODUCTS = [
  { name: 'Espresso', units: 12 },
  { name: 'Latte', units: 9 },
  { name: 'Capuchino', units: 7 },
  { name: 'Americano', units: 5 },
];

function DiaButtonMock({ name, active = false }) {
  return (
    <div
      style={{
        width: '92px',
        height: '32px',
        borderRadius: '9999px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: active ? '#fff' : 'rgba(255, 255, 255, 0.1)',
        color: active ? '#000' : 'rgba(255, 255, 255, 0.45)',
        fontSize: '14px',
        fontWeight: active ? 600 : 500,
        fontFamily: FONT,
      }}
    >
      {name}
    </div>
  );
}

function DiariaDaysRow({ highlight = false }) {
  const wrap = (node) =>
    highlight ? (
      <span className="flex w-fit" style={{ borderRadius: '9999px', boxShadow: TUTORIAL_RING }}>
        {node}
      </span>
    ) : (
      node
    );
  return (
    <div className="flex gap-3 shrink-0 w-full">
      <div className="flex gap-3">
        {DIARIA_DAYS.map((d, i) =>
          wrap(<DiaButtonMock key={d} name={d} active={i === 2} />)
        )}
      </div>
    </div>
  );
}

function BadgeDiarioMock({ label, red = false }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: red ? '#DC0A0B' : 'rgba(217, 217, 217, 0.1)',
        borderRadius: '9999px',
        height: '24px',
        padding: '0 10px',
        fontSize: '14px',
        fontFamily: FONT,
        color: '#fff',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}

function SwitchPillMock({ on = true, highlight = false }) {
  return (
    <span
      className="flex items-center"
      style={highlight ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : {}}
    >
      <span
        className="relative flex items-center"
        style={{ width: '44px', height: '24px', borderRadius: '9999px', backgroundColor: on ? '#0071e3' : 'rgba(255, 255, 255, 0.1)' }}
      >
        <span
          className="absolute bg-white rounded-full"
          style={{ width: '18px', height: '18px', top: '3px', left: on ? '23px' : '3px' }}
        />
      </span>
    </span>
  );
}

function ChevronCircleMock({ expanded = false }) {
  return (
    <div
      className="flex items-center justify-center"
      style={{ width: '28px', height: '28px', borderRadius: '9999px', backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
    >
      <IconChevronDown
        size={16}
        color="#fff"
        style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}
      />
    </div>
  );
}

function ProductCardMock({ name, units, on = true, highlightSwitch = false, highlightUnits = false }) {
  return (
    <div
      className="flex items-center justify-between px-4"
      style={{ height: '70px', borderRadius: '16px', backgroundColor: 'rgba(255, 255, 255, 0.1)', minWidth: 0 }}
    >
      <div className="flex flex-col justify-center min-w-0">
        <span className="text-[rgba(255, 255, 255, 0.45)] font-bold truncate" style={{ fontSize: '14px', fontFamily: FONT }}>
          {name}
        </span>
        <span
          className="flex items-center justify-center mt-1"
          style={{
            fontSize: '14px',
            fontFamily: FONT,
            height: '24px',
            padding: '0 10px',
            borderRadius: '9999px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: 'rgba(255, 255, 255, 0.45)',
            fontWeight: 500,
            width: 'fit-content',
            boxShadow: highlightUnits ? TUTORIAL_RING : undefined,
          }}
        >
          {units} unidades
        </span>
      </div>
      <div className="shrink-0 ml-3">
        <SwitchPillMock on={on} highlight={highlightSwitch} />
      </div>
    </div>
  );
}

function DiariaProductsGrid({ highlightCard = null, highlightUnits = false }) {
  return (
    <div className="grid grid-cols-2 gap-3 w-full mt-3">
      {DIARIA_PRODUCTS.map((p, i) => (
        <ProductCardMock
          key={p.name}
          name={p.name}
          units={p.units}
          on={i !== 3}
          highlightSwitch={highlightCard === i}
          highlightUnits={highlightUnits && highlightCard === i}
        />
      ))}
    </div>
  );
}

function DropdownDiarioMock({ label, active, inactive, on = true, expanded = false, highlightSwitch = false, highlightCard = null }) {
  return (
    <div
      className="flex flex-col w-full shrink-0 overflow-hidden"
      style={{ borderRadius: expanded ? '25px 25px 0 0' : '25px' }}
    >
      <div
        className="flex items-center justify-between px-5"
        style={{ width: '100%', height: '50px', backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
      >
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-white" style={{ fontSize: '14px', fontWeight: 500, fontFamily: FONT }}>
            {label}
          </span>
          <BadgeDiarioMock label={`${active} activos`} />
          <BadgeDiarioMock label={`${inactive} inactivos`} red />
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <SwitchPillMock on={on} highlight={highlightSwitch} />
          <ChevronCircleMock expanded={expanded} />
        </div>
      </div>
      {expanded && (
        <div
          style={{ padding: '4px 0 16px', borderRadius: '0 0 25px 25px', backgroundColor: 'rgba(255, 255, 255, 0.02)' }}
        >
          <div className="px-5">
            <DiariaProductsGrid highlightCard={highlightCard} />
          </div>
        </div>
      )}
    </div>
  );
}

function DiariaHeader() {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Gestión diaria
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Administra las operaciones del día
        </span>
      </div>
      <Busqueda value="" onChange={noop} />
    </div>
  );
}

function SlideDiariaVista() {
  return (
    <div className="flex flex-col gap-3.5 w-full">
      <DiariaHeader />
      <DiariaDaysRow />
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Miércoles
      </span>
      <DropdownDiarioMock label="Bebidas" active={6} inactive={2} expanded />
      <DropdownDiarioMock label="Comida" active={4} inactive={1} on>
        <span className="text-[rgba(255, 255, 255, 0.45)]" style={{ fontSize: '13px', fontFamily: FONT }}>Otros artículos…</span>
      </DropdownDiarioMock>
    </div>
  );
}

function SlideDiariaDia() {
  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <DiariaHeader />
      <DiariaDaysRow highlight />
    </div>
  );
}

function SlideDiariaCategoria() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <DiariaHeader />
      <DiariaDaysRow />
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Miércoles
      </span>
      <DropdownDiarioMock label="Bebidas" active={6} inactive={2} on highlightSwitch />
    </div>
  );
}

function SlideDiariaArticulo() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <DiariaHeader />
      <DiariaDaysRow />
      <span className="text-white font-semibold" style={{ fontSize: '18px', fontFamily: FONT }}>
        Miércoles
      </span>
      <DropdownDiarioMock label="Bebidas" active={6} inactive={2} expanded on highlightCard={1} />
    </div>
  );
}

function SlideDiariaUnidades() {
  return (
    <div className="flex flex-col gap-4 w-full">
      <DiariaHeader />
      <DropdownDiarioMock label="Bebidas" active={6} inactive={2} expanded on highlightCard={0} highlightUnits />
    </div>
  );
}

const DIARIA_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Tu día, día a día',
    text: 'Elige un día de la semana: verás sus categorías, cuántos artículos están activos o inactivos y las unidades que se han vendido.',
    visual: <SlideDiariaVista />,
  },
  {
    caption: 'Elige el día',
    title: 'Programa por día',
    text: 'Toca un botón para cambiar de día. Cada día guarda su propia programación de categorías y artículos.',
    visual: <SlideDiariaDia />,
  },
  {
    caption: 'Categoría por día',
    title: 'Activa o desactiva categorías',
    text: 'El interruptor de cada categoría la activa o desactiva completa para ese día. Los contadores muestran cuántos artículos quedan activos o inactivos.',
    visual: <SlideDiariaCategoria />,
  },
  {
    caption: 'Artículo por día',
    title: 'Cada artículo cuenta',
    text: 'Expande la categoría y activa solo los artículos que quieras ese día, independiente del resto.',
    visual: <SlideDiariaArticulo />,
  },
  {
    caption: 'Unidades del día',
    title: 'Sabes qué rinde',
    text: 'La insignia de cada tarjeta muestra las unidades vendidas del día: así identificas tus artículos más fuertes.',
    visual: <SlideDiariaUnidades />,
  },
];

/* ------------------- Guía: Configuración ------------------- */

function SettingsFieldMock({ label, value, span2 = false, highlight = false }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', gridColumn: span2 ? 'span 2' : 'auto', minWidth: 0 }}>
      <label style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>{label}</label>
      <div
        style={{
          height: '40px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          display: 'flex',
          alignItems: 'center',
          padding: '0 16px',
          boxShadow: highlight ? TUTORIAL_RING : undefined,
        }}
      >
        <span className="text-white" style={{ fontSize: '13px', fontWeight: 500, fontFamily: FONT, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {value}
        </span>
      </div>
    </div>
  );
}

function SettingsCardMock({ title, subtitle, children }) {
  return (
    <div className="flex flex-col gap-4 w-full shrink-0">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '15px', fontFamily: FONT }}>
          {title}
        </span>
        <span className="block" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          {subtitle}
        </span>
      </div>
      {children}
    </div>
  );
}

function ProximamentePillMock({ highlight = false }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        backgroundColor: '#0071e3',
        color: '#fff',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        padding: '5px 10px',
        borderRadius: '9999px',
        boxShadow: highlight ? `${TUTORIAL_RING}, 0 0 12px rgba(3, 78, 162, 0.8)` : '0 0 12px rgba(3, 78, 162, 0.8)',
        whiteSpace: 'nowrap',
      }}
    >
      Próximamente
      <IconQuestionMark size={14} stroke={3} style={{ display: 'block' }} />
    </span>
  );
}

function SettingsToggleMock({ on = true, highlight = false }) {
  return (
    <span className="flex items-center" style={highlight ? { borderRadius: '9999px', boxShadow: TUTORIAL_RING } : { opacity: 0.45, pointerEvents: 'none' }}>
      <span
        className="relative flex items-center"
        style={{ width: '44px', height: '24px', borderRadius: '9999px', backgroundColor: on ? '#0071e3' : 'rgba(255, 255, 255, 0.1)' }}
      >
        <span
          className="absolute bg-white rounded-full"
          style={{ width: '18px', height: '18px', top: '3px', left: on ? '23px' : '3px' }}
        />
      </span>
    </span>
  );
}

function SettingsHeader() {
  return (
    <div className="flex items-center justify-between gap-3 shrink-0 w-full">
      <div>
        <span className="block text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
          Configuración
        </span>
        <span className="block" style={{ fontSize: '12px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT, marginTop: '2px' }}>
          Datos de la sucursal y cobros del punto de venta
        </span>
      </div>
    </div>
  );
}

function GuardarButtonMock({ highlight = false }) {
  return (
    <div className="flex w-full justify-end">
      <span
        className="flex items-center justify-center gap-2 text-white font-semibold"
        style={{
          backgroundColor: '#0071e3',
          height: '36px',
          padding: '0 18px',
          borderRadius: '9999px',
          fontSize: '13px',
          fontFamily: FONT,
          whiteSpace: 'nowrap',
          boxShadow: highlight ? TUTORIAL_RING : '0 8px 24px rgba(0,0,0,0.5)',
        }}
      >
        <IconRocket size={16} />
        Guardar
      </span>
    </div>
  );
}

function SettingsSucursalCard({ highlightField = null }) {
  return (
    <SettingsCardMock title="Datos de la sucursal" subtitle="Información que identifica tu negocio ante clientes y en el ticket.">
      <div className="grid grid-cols-2 gap-4 w-full">
        <SettingsFieldMock label="Nombre de la tienda" value="Nebula Café" span2 highlight={highlightField === 'nombre'} />
        <SettingsFieldMock label="RFC" value="ASR126547892" />
        <SettingsFieldMock label="Teléfono" value="81 1234 5678" />
        <SettingsFieldMock label="Correo electrónico" value="hola@nebula.cafe" span2 />
        <SettingsFieldMock label="Dirección" value="Av. de la Luna 42, Monterrey" span2 />
      </div>
    </SettingsCardMock>
  );
}

function SettingsCobrosCard({ highlightField = null }) {
  return (
    <SettingsCardMock title="Ventas y cobros" subtitle="Parámetros usados en el punto de venta.">
      <div className="grid grid-cols-2 gap-4 w-full">
        <SettingsFieldMock label="Tiempo de preparación (min)" value="20" highlight={highlightField === 'prep'} />
        <SettingsFieldMock label="Moneda" value="MXN" />
        <SettingsFieldMock label="Impuesto (%)" value="16" highlight={highlightField === 'impuesto'} />
        <SettingsFieldMock label="Comisión Crédito (%)" value="3.49" />
        <SettingsFieldMock label="Comisión Débito (%)" value="2.50" />
      </div>
    </SettingsCardMock>
  );
}

function SlideSettingsVista() {
  return (
    <div className="flex flex-col gap-6 w-full">
      <SettingsHeader />
      <SettingsSucursalCard />
      <SettingsCobrosCard />
      <GuardarButtonMock />
    </div>
  );
}

function SlideSettingsSucursal() {
  return (
    <div className="flex flex-col gap-6 w-full items-center">
      <SettingsHeader />
      <SettingsSucursalCard highlightField="nombre" />
    </div>
  );
}

function SlideSettingsCobros() {
  return (
    <div className="flex flex-col gap-6 w-full items-center">
      <SettingsHeader />
      <SettingsCobrosCard highlightField="impuesto" />
    </div>
  );
}

function SlideSettingsGuardar() {
  return (
    <div className="flex flex-col gap-6 w-full items-center">
      <SettingsHeader />
      <SettingsSucursalCard />
      <GuardarButtonMock highlight />
    </div>
  );
}

function SlideSettingsEstado() {
  return (
    <div className="flex flex-col gap-6 w-full items-center">
      <SettingsHeader />
      <SettingsCardMock title="Estado de la tienda" subtitle="Abrir y cerrar tu tienda desde aquí.">
        <div className="flex items-center justify-between gap-4 w-full">
          <div className="flex items-center gap-3 min-w-0">
            <span className="text-white font-semibold" style={{ fontSize: '14px', fontFamily: FONT }}>
              Estado de la tienda
            </span>
            <ProximamentePillMock highlight />
          </div>
          <SettingsToggleMock on highlight />
        </div>
        <p className="m-0" style={{ fontSize: '13px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>
          Próximamente — llega con tu tienda digital
        </p>
      </SettingsCardMock>
    </div>
  );
}

const SETTINGS_SLIDES = [
  {
    caption: 'Vista general',
    title: 'Configura tu negocio',
    text: 'Aquí se guardan los datos de la sucursal y los parámetros del punto de venta: tiempo de preparación, moneda, impuesto y comisiones de tarjeta.',
    visual: <SlideSettingsVista />,
  },
  {
    caption: 'Datos de la sucursal',
    title: 'Identifica tu negocio',
    text: 'Nombre, RFC, teléfono, correo y dirección aparecen ante tus clientes y en el ticket. Mantenlos al día.',
    visual: <SlideSettingsSucursal />,
  },
  {
    caption: 'Ventas y cobros',
    title: 'Parámetros de cobro',
    text: 'El impuesto se aplica en cada venta, el tiempo de preparación estima la entrega y la comisión de débito o crédito se toma según el pago con tarjeta que elija el cliente.',
    visual: <SlideSettingsCobros />,
  },
  {
    caption: 'Guardar',
    title: 'Un clic lo aplica todo',
    text: 'El botón Guardar, siempre visible abajo a la derecha, guarda todos los cambios de la pantalla de una sola vez.',
    visual: <SlideSettingsGuardar />,
  },
  {
    caption: 'Estado de la tienda',
    title: 'Próximamente',
    text: 'Abrir y cerrar tu tienda desde aquí llegará en la próxima versión, junto con tu tienda digital.',
    visual: <SlideSettingsEstado />,
  },
];

const GUIDES = [
  {
    id: 'levantar-pedido',
    title: 'Cómo levantar un pedido',
    description: 'Agrega artículos a tu orden, personalízalos y cobra directamente desde el punto de venta.',
    icon: IconClipboardCheck,
    slides: LEVANTAR_PEDIDO_SLIDES,
  },
  {
    id: 'gestionar-pedidos',
    title: 'Cómo gestionar los pedidos',
    description: 'Da seguimiento a cada pedido por estado: acéptalo, ciérralo, revisa sus detalles o cancélalo.',
    icon: IconClipboardList,
    slides: GESTION_PEDIDOS_SLIDES,
  },
  {
    id: 'gestionar-articulos',
    title: 'Cómo gestionar los artículos',
    description: 'Añade productos al catálogo, edita su información o elimínalos con selección múltiple.',
    icon: IconPackage,
    slides: ARTICULOS_SLIDES,
  },
  {
    id: 'gestionar-promociones',
    title: 'Variantes, categorías y promociones',
    description: 'Crea variantes, agrupa categorías y diseña promociones desde una misma vista.',
    icon: IconDiscount2,
    slides: PROMOCIONES_SLIDES,
  },
  {
    id: 'gestionar-inventario',
    title: 'Cómo gestionar el inventario',
    description: 'Controla insumos y existencias: agrégalos, dales seguimiento y úsalos como ingredientes en tus recetas.',
    icon: IconArchiveFilled,
    slides: INVENTARIO_SLIDES,
  },
  {
    id: 'gestionar-finanzas',
    title: 'Registro de ventas y finanzas',
    description: 'Revisa métricas del mes, filtra por período y consulta o elimina ventas cerradas.',
    icon: IconReceipt,
    slides: VENTAS_SLIDES,
  },
  {
    id: 'gestionar-gastos',
    title: 'Registro de gastos',
    description: 'Lleva el control de compras y gastos: agrégalos, fíltralos por mes y edítalos.',
    icon: IconCashBanknoteFilled,
    slides: GASTOS_SLIDES,
  },
  {
    id: 'gestionar-diaria',
    title: 'Cómo gestionar tu día',
    description: 'Programa por día qué categorías y artículos están disponibles y mira las unidades vendidas.',
    icon: IconCalendar,
    slides: DIARIA_SLIDES,
  },
  {
    id: 'gestionar-configuracion',
    title: 'Configuración general',
    description: 'Actualiza los datos de la sucursal y los parámetros de cobro: impuesto, comisión y tiempo de preparación.',
    icon: IconSettings,
    slides: SETTINGS_SLIDES,
  },
  // Futuras guías van aquí
];

export default function TutorialPOS({ isOpen, onClose }) {
  const [selectedId, setSelectedId] = useState(null);
  const [index, setIndex] = useState(0);

  const guide = GUIDES.find((g) => g.id === selectedId) || null;
  const slide = guide ? guide.slides[index] : null;
  const isLast = guide ? index === guide.slides.length - 1 : false;

  const openGuide = (id) => {
    setIndex(0);
    setSelectedId(id);
  };

  const closeAll = () => {
    setIndex(0);
    setSelectedId(null);
    onClose();
  };

  const goNext = () => {
    if (isLast) {
      closeAll();
      return;
    }
    setIndex((i) => i + 1);
  };

  const goBack = () => setIndex((i) => Math.max(0, i - 1));

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.72)', backdropFilter: 'blur(8px)' }}
      onClick={closeAll}
    >
      <div
        className="flex flex-col rounded-[28px] overflow-hidden"
        style={{
          backgroundColor: '#000',
          border: '1px solid rgba(255, 255, 255, 0.16)',
          width: 'min(880px, 94vw)',
          maxHeight: '92vh',
          boxShadow: '0 40px 120px rgba(0, 0, 0, 0.7)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {guide ? (
          <>
            <header className="flex items-center justify-between gap-4 shrink-0" style={{ padding: '28px 40px 20px' }}>
              <div className="flex items-center gap-4">
                <button
                  onClick={() => setSelectedId(null)}
                  className="flex items-center justify-center shrink-0 cursor-pointer hover:brightness-110 active:scale-95 transition-all"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '9999px',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    backgroundColor: 'transparent',
                  }}
                >
                  <IconArrowLeft size={18} color="#fff" />
                </button>
                <div>
                  <span className="block" style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6F6F6F', fontFamily: FONT }}>
                    {slide.caption}
                  </span>
                  <h2
                    className="text-white font-semibold uppercase m-0"
                    style={{ fontSize: '24px', fontFamily: FONT, marginTop: '6px' }}
                  >
                    {slide.title}
                  </h2>
                </div>
              </div>
              <span style={{ fontSize: '14px', fontWeight: 600, color: 'rgba(255, 255, 255, 0.45)', fontFamily: FONT }}>
                {index + 1} / {guide.slides.length}
              </span>
            </header>

            <div className="flex-1 min-h-0 overflow-y-auto" style={{ padding: '0 40px' }}>
              <div
                className="flex items-center justify-center rounded-2xl"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(255, 255, 255, 0.06)',
                  padding: '28px',
                }}
              >
                {slide.visual}
              </div>

              <p
                className="m-0"
                style={{ fontSize: '15px', fontWeight: 500, color: '#B5B5B5', lineHeight: 1.6, fontFamily: FONT, padding: '20px 4px 4px' }}
              >
                {slide.text}
              </p>
            </div>

            <footer className="flex items-center shrink-0" style={{ padding: '22px 40px 30px' }}>
              <button
                onClick={goBack}
                disabled={index === 0}
                className="flex items-center justify-center gap-2 font-medium cursor-pointer disabled:cursor-default active:scale-95 transition-all"
                style={{
                  width: '128px',
                  height: '42px',
                  borderRadius: '9999px',
                  border: index === 0 ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(255, 255, 255, 0.18)',
                  backgroundColor: 'transparent',
                  color: index === 0 ? '#3A3A3A' : '#fff',
                  fontSize: '14px',
                  fontFamily: FONT,
                  visibility: index === 0 ? 'hidden' : 'visible',
                }}
              >
                <IconArrowLeft size={16} />
                Anterior
              </button>

              <div className="flex-1 flex items-center justify-center gap-2">
                {guide.slides.map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: i === index ? '22px' : '7px',
                      height: '7px',
                      borderRadius: '9999px',
                      backgroundColor: i === index ? '#fff' : 'rgba(255, 255, 255, 0.18)',
                      transition: 'all 0.25s ease',
                    }}
                  />
                ))}
              </div>

              <button
                onClick={goNext}
                className="flex items-center justify-center gap-2 font-medium cursor-pointer hover:brightness-110 active:scale-95 transition-all"
                style={{
                  width: '128px',
                  height: '42px',
                  borderRadius: '9999px',
                  border: 'none',
                  backgroundColor: '#fff',
                  color: '#000',
                  fontSize: '14px',
                  fontFamily: FONT,
                }}
              >
                {isLast ? 'Terminar' : 'Siguiente'}
                {!isLast && <IconArrowRight size={16} />}
              </button>
            </footer>
          </>
        ) : (
          <>
            <header className="flex items-center justify-between shrink-0" style={{ padding: '34px 40px 24px' }}>
              <div>
                <span className="block" style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6F6F6F', fontFamily: FONT }}>
                  Centro de ayuda
                </span>
                <h2
                  className="text-white font-semibold uppercase m-0"
                  style={{ fontSize: '24px', fontFamily: FONT, marginTop: '6px' }}
                >
                  Guías de ayuda
                </h2>
              </div>
            </header>

            <div className="flex-1 min-h-0 overflow-y-auto" style={{ padding: '8px 40px 12px' }}>
              <div
                className="grid gap-4 items-stretch"
                style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}
              >
                {GUIDES.map((g) => {
                  const GuideIcon = g.icon;
                  return (
                    <button
                      key={g.id}
                      onClick={() => openGuide(g.id)}
                      className="flex flex-col items-start text-left cursor-pointer hover:brightness-110 active:scale-[0.98] transition-all"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.035)',
                        border: '1px solid rgba(255, 255, 255, 0.16)',
                        borderRadius: '20px',
                        padding: '24px',
                        gap: '14px',
                        fontFamily: FONT,
                      }}
                    >
                      <span
                        className="flex items-center justify-center shrink-0"
                        style={{
                          width: '44px',
                          height: '44px',
                          borderRadius: '9999px',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        }}
                      >
                        <GuideIcon size={22} color="#fff" />
                      </span>
                      <span className="text-white font-semibold" style={{ fontSize: '16px', fontFamily: FONT }}>
                        {g.title}
                      </span>
                      <span className="text-[rgba(255, 255, 255, 0.45)]" style={{ fontSize: '13px', fontWeight: 500, lineHeight: 1.5, fontFamily: FONT }}>
                        {g.description}
                      </span>
                      <span
                        className="flex items-center gap-1.5"
                        style={{ fontSize: '13px', fontWeight: 600, color: '#6EA8F0', fontFamily: FONT, marginTop: '4px' }}
                      >
                        Ver guía
                        <IconArrowRight size={14} />
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>

            <footer className="flex justify-end shrink-0" style={{ padding: '22px 40px 30px' }}>
              <button
                onClick={closeAll}
                className="flex items-center justify-center font-medium cursor-pointer hover:brightness-110 active:scale-95 transition-all"
                style={{
                  height: '42px',
                  padding: '0 24px',
                  borderRadius: '9999px',
                  border: 'none',
                  backgroundColor: '#fff',
                  color: '#000',
                  fontSize: '14px',
                  fontFamily: FONT,
                }}
              >
                Cerrar
              </button>
            </footer>
          </>
        )}
      </div>
    </div>
  );
}